import { type StateCreator } from 'zustand';

export type ChatSidebarSlice = {
  open: boolean;
  touched: boolean;
  clearOpen: () => void;
  setOpen: (open: boolean) => void;
  toggleOpen: () => void;
};

export type CreateChatSidebarSlice = (
  initialState?: Pick<Partial<ChatSidebarSlice>, 'open' | 'touched'>,
) => StateCreator<ChatSidebarSlice, [], [], ChatSidebarSlice>;

export const createChatSidebarSlice: CreateChatSidebarSlice =
  (initialState = {}) =>
  (set) => ({
    clearOpen: () =>
      set({
        open: initialState.open ?? true,
        touched: initialState.touched ?? false,
      }),
    open: initialState.open ?? true,
    setOpen: (open) => set({ open, touched: true }),
    toggleOpen: () => set((state) => ({ open: !state.open, touched: true })),
    touched: initialState.touched ?? false,
  });
